<template>
  <div class="dashboard-container">
    <div class="balloons">
      <div class="balloon balloon-1">🎈</div>
      <div class="balloon balloon-2">🎈</div>
      <div class="balloon balloon-3">🎈</div>
      <div class="balloon balloon-4">🎈</div>
      <div class="balloon balloon-5">🎈</div>
    </div>

    <div class="dashboard-header">
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>

      <div class="breadcrumb-nav">
        <ol class="breadcrumb-list">
          <li class="breadcrumb-item">
            <a class="breadcrumb-link">MENÚ PRINCIPAL</a>
          </li>
          <li class="breadcrumb-separator">/</li>
          <li class="breadcrumb-item active">
            <span class="breadcrumb-current">INICIO</span>
          </li>
        </ol>
      </div>

      <div class="welcome-header">
        <h1 class="welcome-title">
          <span class="welcome-text">¡Bienvenido!:</span>
          <span class="username">{{ user.name }}</span>
        </h1>
        <div class="welcome-icon">🎉</div>
      </div>
    </div>

    <div class="compact-cards">
      <div class="grid">
        <div
          class="col-12 sm:col-6 lg:col-4"
          v-if="'Producto Crear' in (authService.user?.permissions || {})"
        >
          <div class="compact-card product-card">
            <div class="card-icon">
              <i class="pi pi-box"></i>
            </div>
            <div class="card-content">
              <div class="card-value">{{ productos }}</div>
              <div class="card-label">Productos</div>
            </div>
            <router-link
              to="/productos"
              class="card-action"
              v-tooltip.top="'Ver Listado Productos'"
            >
              <i class="pi pi-eye"></i>
            </router-link>
          </div>
        </div>

        <div
          class="col-12 sm:col-6 lg:col-4"
          v-if="'Cliente Crear' in (authService.user?.permissions || {})"
        >
          <div class="compact-card client-card">
            <div class="card-icon">
              <i class="pi pi-users"></i>
            </div>
            <div class="card-content">
              <div class="card-value">{{ clientes }}</div>
              <div class="card-label">Clientes</div>
            </div>
            <router-link
              to="/clientes"
              class="card-action"
              v-tooltip.top="'Ver Listado Clientes'"
            >
              <i class="pi pi-eye"></i>
            </router-link>
          </div>
        </div>

        <div
          class="col-12 sm:col-6 lg:col-4"
          v-if="'Proveedor Crear' in (authService.user?.permissions || {})"
        >
          <div class="compact-card supplier-card">
            <div class="card-icon">
              <i class="pi pi-users"></i>
            </div>
            <div class="card-content">
              <div class="card-value">{{ proveedores }}</div>
              <div class="card-label">Proveedores</div>
            </div>
            <router-link
              to="/proveedores"
              class="card-action"
              v-tooltip.top="'Ver Listado Proveedores'"
            >
              <i class="pi pi-eye"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="grid p-fluid formgrid">
      <div class="field col-12 md:col-6">
        <div class="data-section" v-if="tiene_permiso_caja">
          <div class="section-header">
            <h2 class="section-title">
              <i class="pi pi-calendar"></i>
              Últimas Cajas Aperturadas
            </h2>
          </div>
          <DataTable
            ref="ultimas_cajas"
            key="id"
            :value="ultimas_cajas"
            responsiveLayout="scroll"
            class="p-datatable-sm data-table"
            responsive="true"
            stripedRows
            showGridlines
          >
            <template #empty>
              <div class="empty-message">
                <i class="pi pi-info-circle"></i>
                <p>No existen Cajas Activas en este momento</p>
              </div>
            </template>
            <Column header="#">
              <template #body="slotProps">
                {{ 1 + slotProps.index }}
              </template>
            </Column>
            <Column field="nombre_user" header="USUARIO" />
            <Column field="fechas" header="F.APERTURA - F.CIERRE">
              <template #body="{ data }">
                {{ data.fecha_apertura }} - {{ data.fecha_cierre ?? "-" }}
              </template>
            </Column>
            <Column field="estado" header="ESTADO" class="text-center">
              <template #body="{ data }">
                <span
                  :class="
                    data.estado == 1
                      ? 'status-badge active'
                      : 'status-badge inactive'
                  "
                >
                  {{ data.estado == 1 ? "ACTIVO" : "INACTIVO" }}
                </span>
              </template>
            </Column>
            <Column header="ACCIONES" class="text-center">
              <template #body="slotProps">
                <Button
                  v-tooltip.top="'Imprimir detalle de Caja'"
                  icon="pi pi-file-pdf"
                  class="p-button-rounded p-button-text p-button-danger action-btn"
                  @click="imprimirCaja(slotProps.data.id)"
                  :loading="imprimiendo"
                />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>

      <div :class="tiene_permiso_caja ? 'col-12 md:col-6' : 'col-12'">
        <div class="alert-panels">
          <Panel
            v-if="
              'Dashboard ProductosStockCero' in authService.user.permissions
            "
            header="PRODUCTOS CON STOCK EN CERO"
            :toggleable="true"
            :collapsed="true"
            class="alert-panel"
          >
            <div class="filter-group mb-3">
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="buscar['global'].value"
                  placeholder="Buscar producto..."
                />
              </span>
            </div>
            <DataTable
              ref="dtproductosstockcero"
              :value="stocks"
              :paginator="true"
              :rows="5"
              :loading="enviando"
              responsiveLayout="scroll"
              :rowsPerPageOptions="[5, 10, 20]"
              :filters="buscar"
              class="p-datatable-sm alert-table"
            >
              <template #loading>
                <div class="loading-spinner">
                  <ProgressSpinner />
                </div>
              </template>
              <template #empty>
                <div class="empty-message success-message">
                  <i class="pi pi-check-circle"></i>
                  <p>¡Excelente! No hay productos con stock en cero</p>
                </div>
              </template>
              <Column field="nombre_sucursal" header="Sucursal"></Column>
              <Column field="nombre_fabrica" header="Laboratorio"></Column>
              <Column field="nombre_producto" header="Producto"></Column>
              <Column field="cantidad" header="Stock" class="text-right">
                <template #body="{ data }">
                  <span class="stock-badge zero-stock">{{
                    data.cantidad
                  }}</span>
                </template>
              </Column>
            </DataTable>
          </Panel>

          <Panel
            v-if="
              'Dashboard ProductosFechaVence' in authService.user.permissions
            "
            header="PRODUCTOS QUE VENCEN"
            :toggleable="true"
            :collapsed="true"
            class="alert-panel"
          >
            <div class="filter-group mb-3">
              <span class="filter-label">
                <i class="pi pi-calendar"></i>
                Días para vencer:
              </span>
              <Dropdown
                v-model="diaSelected"
                :options="dias_vencimientos"
                optionLabel="label"
                optionValue="value"
                placeholder="SELECCIONE"
                class="filter-dropdown"
                @change="Obtenerproductos_fecha_vence()"
              />
            </div>
            <DataTable
              ref="dtproductos_fecha_vence"
              :value="productos_fecha_vence"
              :rows="5"
              :paginator="true"
              :loading="enviando"
              responsiveLayout="scroll"
              :rowsPerPageOptions="[5, 10, 20]"
              class="p-datatable-sm alert-table"
            >
              <template #loading>
                <div class="loading-spinner">
                  <ProgressSpinner />
                </div>
              </template>
              <template #empty>
                <div class="empty-message success-message">
                  <i class="pi pi-check-circle"></i>
                  <p>No hay productos próximos a vencer</p>
                </div>
              </template>
              <Column field="nombre_laborario" header="Marca"></Column>
              <Column field="nombre_producto" header="Producto"></Column>
              <Column field="fecha_vence" header="Vencimiento">
                <template #body="{ data }">
                  <span class="date-badge">{{ data.fecha_vence }}</span>
                </template>
              </Column>
            </DataTable>
          </Panel>

          <Panel
            v-if="
              'Dashboard ProductosStockMin' in
              (authService.user?.permissions || {})
            "
            header="PRODUCTOS CON STOCK MÍNIMO"
            :toggleable="true"
            :collapsed="true"
            class="alert-panel"
          >
            <div class="filter-group mb-3">
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="buscar['global'].value"
                  placeholder="Buscar producto..."
                />
              </span>
            </div>
            <DataTable
              ref="dtproductos_stock_minimo"
              :value="productos_stock_minimo"
              :rows="5"
              :paginator="true"
              :loading="enviando"
              responsiveLayout="scroll"
              :rowsPerPageOptions="[5, 10, 20]"
              :filters="buscar"
              class="p-datatable-sm alert-table"
            >
              <template #loading>
                <div class="loading-spinner">
                  <ProgressSpinner />
                </div>
              </template>
              <template #empty>
                <div class="empty-message success-message">
                  <i class="pi pi-check-circle"></i>
                  <p>No hay productos con stock mínimo</p>
                </div>
              </template>
              <Column field="nombre_laboratorio" header="Marca"></Column>
              <Column field="nombre_producto" header="Producto"></Column>
              <Column field="stock_minimo" header="Mínimo"></Column>
              <Column field="stock_actual" header="Actual">
                <template #body="{ data }">
                  <span
                    :class="[
                      'stock-badge',
                      data.stock_actual <= data.stock_minimo
                        ? 'low-stock'
                        : 'ok-stock',
                    ]"
                  >
                    {{ data.stock_actual }}
                  </span>
                </template>
              </Column>
            </DataTable>
          </Panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import Panel from "primevue/panel";
import { useAuth } from "@/stores";
import ProductService from "@/service/ProductService";
import StockService from "@/service/StockService";
import UserService from "@/service/UserService";
import CajaService from "@/service/CajaService";

export default {
  components: {
    Panel,
  },
  data() {
    return {
      user: {},
      productos: null,
      clientes: null,
      proveedores: null,
      stocks: [],
      enviando: false,
      productos_fecha_vence: [],
      productos_stock_minimo: [],
      stockClass: (data) => {
        if (data.cantidad == 0) {
          return "text-red-500";
        }
      },
      collapsed: false,
      productos_mas_vendidos: [],
      buscar: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
      dias_vencimientos: [
        { label: "30 DÍAS", value: "30" },
        { label: "60 DÍAS", value: "60" },
        { label: "90 DÍAS", value: "90" },
        { label: "120 DÍAS", value: "120" },
      ],
      diaSelected: "30",
      txtStockCero: 0,
      ultimas_cajas: [],
      imprimiendo: false,
      tiene_permiso_caja: false,
    };
  },
  authService: null,
  productService: null,
  stockService: null,
  cajaService: null,

  created() {
    this.authService = useAuth();
    this.productService = new ProductService();
    this.userService = new UserService();
    this.stockService = new StockService();
    this.cajaService = new CajaService();
  },
  mounted() {
    this.user = { ...this.authService.user };
    this.productosStockCero2();
    this.Obtenerproductos_fecha_vence();
    this.Obtenerproductos_stock_minimo();
    this.panel_necesario_auth();
    if ("Dashboard Cajas" in this.authService.user.permissions) {
      this.tiene_permiso_caja = true;
    }
  },
  methods: {
    imprimirCaja(id) {
      this.imprimiendo = true;
      this.cajaService
        .imprimirCaja(id)
        .then(() => {
          this.imprimiendo = false;
        })
        .catch((error) => console.log(error));
    },
    toggle(event) {
      this.$refs.menu.toggle(event);
    },
    Obtenerproductos_fecha_vence() {
      if (this.collapsed == true) {
        this.enviando = false;
      } else {
        this.enviando = true;
        let datos = {
          diaSelected: this.diaSelected ?? null,
        };

        this.productService
          .getProductos_fecha_vence2(datos)
          .then((data) => {
            this.productos_fecha_vence = data.productos_fecha_vence ?? [];
            this.enviando = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    Obtenerproductos_stock_minimo() {
      if (this.collapsed == true) {
        this.enviando = false;
      } else {
        this.enviando = true;
        this.productService
          .getProductos_stock_minimo()
          .then((data) => {
            this.productos_stock_minimo = data.productos_stock_minimo;
            this.enviando = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    productosStockCero2() {
      if (this.collapsed == true) {
        this.enviando = false;
      } else {
        this.enviando = true;
        let datos = {
          txtStockCero: this.txtStockCero ?? null,
        };
        this.stockService.productos_stock_cero2(datos).then((data) => {
          this.stocks = data.stocks;
          this.enviando = false;
        });
      }
    },
    panel_necesario_auth() {
      let datos = {
        id: this.user.id,
        panel: "panel_inicio",
      };
      this.userService.panel_necesario_auth(datos).then((data) => {
        this.productos = data.datos.total_productos ?? 0;
        this.clientes = data.datos.clientes ?? 0;
        this.proveedores = data.datos.proveedors ?? 0;
        this.productos_mas_vendidos = data.datos.productos_mas_vendidos ?? 0;
        this.ultimas_cajas = data.datos.ultimas_cajas ?? [];
      });
    },
  },
};
</script>

<style scoped lang="scss">
.dashboard-container {
  padding: 1.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  border: 1px solid #eee;
}

/* Globos */
.balloons {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.balloon {
  position: absolute;
  font-size: 2rem;
  animation: float 8s infinite ease-in-out;
  opacity: 0.7;
}

.balloon-1 {
  top: 10%;
  left: 5%;
  animation-delay: 0s;
}

.balloon-2 {
  top: 15%;
  right: 10%;
  animation-delay: 1s;
}

.balloon-3 {
  top: 25%;
  left: 15%;
  animation-delay: 2s;
}

.balloon-4 {
  top: 20%;
  right: 20%;
  animation-delay: 3s;
}

.balloon-5 {
  top: 30%;
  left: 25%;
  animation-delay: 4s;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(5deg);
  }
}

/* Confetti */
.dashboard-header {
  position: relative;
  margin-bottom: 2rem;
  z-index: 2;
}

.confetti {
  position: absolute;
  width: 10px;
  height: 10px;
  background: #ff6b6b;
  opacity: 0.7;
  animation: confetti-fall 5s infinite linear;

  &:nth-child(2) {
    background: #4ecdc4;
    left: 10%;
    animation-delay: 1s;
  }

  &:nth-child(3) {
    background: #ffd166;
    left: 20%;
    animation-delay: 2s;
  }

  &:nth-child(4) {
    background: #06d6a0;
    left: 30%;
    animation-delay: 3s;
  }

  &:nth-child(5) {
    background: #118ab2;
    left: 40%;
    animation-delay: 4s;
  }
}

@keyframes confetti-fall {
  0% {
    transform: translateY(-100px) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(500px) rotate(360deg);
    opacity: 0;
  }
}

/* Breadcrumb */
.breadcrumb-nav {
  margin-bottom: 1rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  padding: 0.5rem 1rem;
}

.breadcrumb-list {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 0.5rem;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
}

.breadcrumb-link {
  color: #6c757d;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
}

.breadcrumb-separator {
  color: #6c757d;
}

.breadcrumb-current {
  color: #2c3e50;
  font-weight: 600;
  font-size: 0.9rem;
}

/* Welcome Header */
.welcome-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.welcome-title {
  display: flex;
  margin: 0;
  gap: 0.5rem;
}

.welcome-text {
  font-size: 1.5rem;
  color: #6c757d;
  font-weight: 500;
}

.username {
  font-size: 1.5rem;
  color: #2c3e50;
  font-weight: 700;
  background: linear-gradient(135deg, #3498db, #2c3e50);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.welcome-icon {
  font-size: 2.5rem;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
}

/* Tarjetas compactas */
.compact-cards {
  margin-bottom: 1rem;
  position: relative;
  z-index: 2;
}

.compact-card {
  background: white;
  border-radius: 16px;
  padding: 1rem;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.3s ease;
  height: 100%;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
  }
}

.card-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
}

.product-card .card-icon {
  background: linear-gradient(135deg, #3498db, #2c3e50);
  color: white;
}

.client-card .card-icon {
  background: linear-gradient(135deg, #ff6384, #c90035);
  color: white;
}

.supplier-card .card-icon {
  background: linear-gradient(135deg, #ff9f40, #ff7f00);
  color: white;
}

.card-content {
  flex: 1;
}

.card-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
  line-height: 1.2;
}

.card-label {
  font-size: 0.85rem;
  color: #6c757d;
  font-weight: 500;
}

.card-action {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3498db;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: #3498db;
    color: white;
    transform: scale(1.1);
  }
}

.action-btn {
  width: 36px;
  height: 36px;
}

/* Sección de datos */
.data-section {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 2;
}

.section-header {
  margin-bottom: 1.5rem;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #2c3e50;
  font-size: 1.25rem;
  margin: 0;
  font-weight: 600;

  i {
    color: #3498db;
  }
}

.data-table {
  :deep(.p-datatable-header) {
    border: none;
    padding: 0 0 1rem 0;
    background: transparent;
  }
}

/* Paneles de alertas */
.alert-panels {
  position: relative;
  z-index: 2;
}

.alert-panel {
  margin-bottom: 1rem;
  border-radius: 12px;
  overflow: hidden;

  :deep(.p-panel-header) {
    background: linear-gradient(135deg, #3498db, #2c3e50);
    border-bottom: 1px solid #dee2e6;
    font-weight: 600;
    color: #ffffff;
    padding: 1rem;
  }

  :deep(.p-panel-content) {
    padding: 1rem;
  }
}

.alert-table {
  :deep(.p-datatable-header) {
    border: none;
    padding: 0;
    background: transparent;
  }
}

.filter-group {
  display: flex;
  gap: 0.75rem;
  align-items: center;

  .p-input-icon-left {
    width: 100%;
  }
}

.filter-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #2c3e50;
  font-weight: 600;
  font-size: 0.9rem;
  white-space: nowrap;

  i {
    color: #3498db;
  }
}

.filter-dropdown {
  min-width: 200px;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  padding: 2rem;
}

.empty-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #6c757d;

  i {
    font-size: 2rem;
    margin-bottom: 0.5rem;
  }

  p {
    margin: 0;
    font-style: italic;
  }
}

.success-message {
  color: #28a745;
}

/* Badges */
.stock-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.85rem;
}

.zero-stock {
  background: #ffebee;
  color: #dc3545;
}

.low-stock {
  background: #fff3cd;
  color: #856404;
}

.ok-stock {
  background: #d4edda;
  color: #155724;
}

.date-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  background: #e3f2fd;
  color: #0d6efd;
  font-weight: 600;
  font-size: 0.85rem;
}

.status-badge {
  padding: 0.35rem 0.75rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.85rem;

  &.active {
    background: #d4edda;
    color: #155724;
  }

  &.inactive {
    background: #f8d7da;
    color: #721c24;
  }
}

/* Responsive */
@media (max-width: 960px) {
  .welcome-header {
    flex-direction: column;
    text-align: center;
  }

  .filter-group {
    flex-direction: column;

    .p-input-icon-left {
      width: 100%;
    }
  }
}

@media (max-width: 640px) {
  .dashboard-container {
    padding: 1rem;
  }

  .compact-card {
    text-align: center;
    gap: 0.75rem;
  }

  .welcome-text {
    font-size: 1.25rem;
  }

  .username {
    font-size: 1.25rem;
  }

  .section-title {
    font-size: 1.1rem;
  }
}
</style>
